<app-filter-panel [quickSearchFilter]="filters.name" quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 align-items-center justify-content-between mb-3">
  <span class="p-input-icon-right">
    <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()" />
    <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer" (click)="clearFilters()"></i>
  </span>
  <p-button label="Nuevo plan" icon="pi pi-plus" (click)="edit(null)"></p-button>
</div>
-->

<p-table #grid [value]="dialPlans" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
  [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
  [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
      <th width="120"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-dialPlan>
    <tr (dblclick)="edit(dialPlan.id)" class="cursor-pointer">
      <td>{{dialPlan.name}}</td>
      <td>
        <div class="flex gap-2 justify-content-end">
          <p-button (click)="delete(dialPlan)" [rounded]="true" [text]="false" severity="danger"
            pTooltip="Eliminar plan" tooltipPosition="top">
            <i class="pi pi-trash"></i>
          </p-button>
          <p-button (click)="edit(dialPlan.id)" [rounded]="true" [text]="false"
            pTooltip="Editar plan" tooltipPosition="top">
            <i class="pi pi-pencil"></i>
          </p-button>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="2">No se han encontrado planes</td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>
